import { useRecordContext } from "ra-core";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

import type { Sale } from "../types";

const fullName = (sale: Sale) =>
  `${sale.first_name ?? ""} ${sale.last_name ?? ""}`.trim();

/**
 * Full name of the user (owner) in the current record context. Used inside
 * a <ReferenceField reference="sales"> so the name also shows where the
 * "sales" resource has no recordRepresentation (e.g. the mobile admin).
 */
export const SaleName = () => {
  const record = useRecordContext<Sale>();
  if (!record) return null;
  return <>{fullName(record)}</>;
};

/** Small initials avatar of the user in the current record context */
export const SaleInitials = () => {
  const record = useRecordContext<Sale>();
  if (!record) return null;
  const initials = `${record.first_name?.charAt(0) ?? ""}${
    record.last_name?.charAt(0) ?? ""
  }`.toUpperCase();
  return (
    <Avatar className="size-6" title={fullName(record)}>
      <AvatarFallback className="text-[10px] font-medium">
        {initials}
      </AvatarFallback>
    </Avatar>
  );
};
